import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  fieldContainer: {
    display: "flex",
    gap: "32px",
    borderBottom: `1px solid ${theme.palette.border?.secondary}`,
    "&:not(:first-of-type)": {
      padding: "16px 0",
    },
    "& label": {
      width: "228px",
      fontSize: "14px",
      fontWeight: 600,
      [theme.breakpoints.down("426")]: {
        width: "100px",
      },
    },
    [theme.breakpoints.down("426")]: {
      flexWrap: "wrap",
    },
  },

  googleMaps: {
    minHeight: "350px !important",
    "& > div": {
      minHeight: "350px !important",
    },
  },
}));
